<template>
    <section class="tables">
        <vue-snotify></vue-snotify>
        <h1 class="page-header">Update Seminar Packing Item</h1>
        <div class="inner_patient_report">
            <form class="forms-sample" action="" method="post" @submit.prevent="editSeminar" autocomplete="off">
                <div class="row mt-5">
                    <div class="col-md-12 d-flex align-items-stretch grid-margin">
                        <div class="row flex-grow">
                            <div class="col-12 grid-margin">

                                <div class="card">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <b-form-group label="Item Name" label-for="itemName">
                                                    <b-form-input type="text" id="itemName" name="itemName"
                                                        autocomplete="itemName" placeholder="Item Name"
                                                        :state="$v.seminarData.ItemName.$dirty ? !$v.seminarData.ItemName.$error : null"
                                                        v-model="seminarData.ItemName">
                                                    </b-form-input>
                                                    <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                                        field.
                                                    </b-form-invalid-feedback>
                                                </b-form-group>
                                                <b-form-group id="quantity" label="Quantity" label-for="quantity">
                                                    <b-form-input id="quantity" v-model="seminarData.Quantity"
                                                        :state="$v.seminarData.Quantity.$dirty ? !$v.seminarData.Quantity.$error : null"
                                                        type="number"></b-form-input>
                                                    <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                                        field.
                                                    </b-form-invalid-feedback>
                                                </b-form-group>

                                                <b-form-group>
                                                    <div class="checkboxes row">
                                                        <div class="checkbox-field col-md-4 ">
                                                            <th> <label for="m1">Module 1</label> <input
                                                                    v-model="seminarData.Marketing" id="m1" type="checkbox">
                                                            </th>
                                                        </div>
                                                        <div class="checkbox-field col-md-4 ">
                                                            <th><label for="m2">Module 2</label> <input
                                                                    v-model="seminarData.NewPatients" id="m2"
                                                                    type="checkbox"></th>
                                                        </div>
                                                        <div class="checkbox-field col-md-4 ">
                                                            <th><label for="m3">Module 3</label> <input
                                                                    v-model="seminarData.Conversion" id="m3"
                                                                    type="checkbox"></th>
                                                        </div>
                                                        <div class="checkbox-field col-md-4 ">
                                                            <th><label for="m4">Module 4</label> <input
                                                                    v-model="seminarData.Retention" id="m4" type="checkbox">
                                                            </th>
                                                        </div>
                                                        <div class="checkbox-field col-md-4 ">
                                                            <th><label for="m5">Module 5</label> <input
                                                                    v-model="seminarData.Revenue" id="m5" type="checkbox">
                                                            </th>
                                                        </div>
                                                        <div class="checkbox-field col-md-4 ">
                                                            <th><label for="m6">Module 6</label> <input
                                                                    v-model="seminarData.TeamDevelopment" id="m6"
                                                                    type="checkbox"></th>
                                                        </div>
                                                    </div>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-6 transaction-textarea">
                                                <b-form-group label="Description:" label-for="Description">
                                                    <b-form-textarea id="Description" v-model="seminarData.Description"
                                                    :state="$v.seminarData.Description.$dirty ? !$v.seminarData.Description.$error : null"
                                                        placeholder="Enter something..." rows="3" max-rows="6">
                                                    </b-form-textarea>
                                                    <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                                        field.
                                                    </b-form-invalid-feedback>
                                                </b-form-group>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6"></div>
                                            <div class="col-md-6 mt-3">
                                                <b-button type="submit" variant="success"
                                                    class="btn float-right btn-success">
                                                    Update
                                                </b-button>
                                            </div>
                                        </div>
                                        <!--                                </form>-->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </section>
</template>

<script>
import Vue from "vue";
import API from '@/api'
import { validationMixin } from "vuelidate";
import { required, integer } from "vuelidate/lib/validators";
import router from '../router';

export default {
    name: "add_seminar",
    mixins: [validationMixin],
    data() {
        return {
            seminarData: {
                ItemName: "",
                Description: "",
                Quantity: null,
                Marketing: 0,
                NewPatients: 0,
                Conversion: 0,
                Retention: 0,
                Revenue: 0,
                TeamDevelopment: 0
            },

        }
    },
    validations: {
        seminarData: {
            ItemName: {
                required,
            },
            Description: {
                required,
            },
            Quantity: {
                required, integer
            }
        }
    },
    methods: {
        seminarDataFromRouter(){
            if(this.$route.params.item == undefined || this.$route.params.item == '')
            {
                router.push({name:'view_seminar'})
                return ;
            }
            this.seminarData = this.$route.params.item
            this.checkbox = this.$route.params.item
            this.seminarData.Marketing = (this.checkbox.Marketing == 1?true:false)
            this.seminarData.NewPatients = this.checkbox.NewPatients == 1?true:false
            this.seminarData.Conversion = this.checkbox.Conversion == 1?true:false
            this.seminarData.Retention = this.checkbox.Retention == 1?true:false
            this.seminarData.Revenue = this.checkbox.Revenue == 1?true:false
            this.seminarData.TeamDevelopment = this.checkbox.TeamDevelopment == 1?true:false
        },
        editSeminar() {
            this.$v.seminarData.$touch();
            if (this.$v.seminarData.$anyError) {
                return;
            }
            API.editSeminar(this.seminarData, this.editSeminarCB, this.errorCB);
        },
        editSeminarCB(res) {
            // this.$showNotification(res,"success")
            this.$router.push({name: 'view_seminar'});
        },
        errorCB(err) {
            console.log(err);
            this.$showNotification({message:'Failed system error'},"error")
        },
    },
    mounted(){
        this.seminarDataFromRouter()
    },
    components: {}
}
</script>
